import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../core/guards/auth.guard';
import { ContactResolverService } from '../../resolvers/contact-resolver.service'
import { ContactsResolverService } from '../../resolvers/contacts-resolver.service'
import { ContactFormComponent } from './contact-form/contact-form.component'
import { ContactsListComponent } from './contacts-list/contacts-list.component'


const routes: Routes = [
    {
        path: 'kontakty',
        canActivate: [
            AuthGuard
        ],
        children: [
            {
                path: '',
                component: ContactsListComponent,
                data: {
                    pageTitle: 'Książka adresowa'
                },
                resolve: {
                    items: ContactsResolverService
                }
            },
            {
                path: 'dodaj',
                component: ContactFormComponent,
                data: {
                    pageTitle: 'Książka adresowa'
                },
                resolve: {
                }
            },
            {
                path: ':id',
                component: ContactFormComponent,
                data: {
                    pageTitle: 'Książka adresowa'
                },
                resolve: {
                    contact: ContactResolverService
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ContactsRoutingModule { }
